"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DISCOUNT_TYPE_LABELS = void 0;
exports.DISCOUNT_TYPE_LABELS = {
    percentage: 'Percentage',
    fixed_amount: 'Fixed Amount',
    free_shipping: 'Free Shipping',
};
